export default "__VITE_ASSET__DGqvK5lD__"